import React from "react";

const AuditIcon = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.375 10.875L1.37676 8.27614C1.37676 8.18952 1.4138 8.10644 1.47972 8.04519C1.54565 7.98394 1.63507 7.94953 1.72831 7.94953H5.24453C5.56866 7.94953 5.5669 7.68236 5.5669 7.04677C5.5669 6.41118 3.84359 5.87586 3.84359 3.6415C3.84359 1.40715 5.62877 0.75 7.11232 0.75C8.59587 0.75 10.212 1.40715 10.212 3.6415C10.212 5.87586 8.49779 6.23122 8.49779 7.04677C8.49779 7.86232 8.49779 7.94953 8.772 7.94953H12.2734C12.3667 7.94953 12.4561 7.98394 12.522 8.04519C12.588 8.10644 12.625 8.18952 12.625 8.27614V10.875H1.375Z"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AuditIcon;
